import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MedicalStaffComponent } from './medical-staff.component';
import { TopBarComponent } from './top-bar/top-bar.component';

@NgModule({
  declarations: [
    MedicalStaffComponent,
    TopBarComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    MedicalStaffComponent,
    TopBarComponent
  ]
})
export class MedicalStaffLayoutModule { }
